import { render, staticRenderFns } from "./ScanFormDPTable.vue?vue&type=template&id=2275af40&scoped=true"
import script from "./ScanFormDPTable.vue?vue&type=script&lang=js"
export * from "./ScanFormDPTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2275af40",
  null
  
)

export default component.exports